import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import Checkbox from "../ui/checkbox/Checkbox";
import "./consents.scss"

function Consents({ consents, control, errors }) {
    return (
        <div className="consents">
            {consents.map((consent, index) => {
                const hasChannels = consent.hasCommunicationChannels;
                const channels = consent.availableChannels ?? {};

                return (
                    <div key={consent.consentType}>
                        <div className="consents--item">
                            <div
                                dangerouslySetInnerHTML={{
                                    __html: consent.content + "<span>*</span>",
                                }}
                            />

                            {!hasChannels && (
                                <>
                                    <div
                                        className={clsx(
                                            "danger",
                                            errors.consents?.[index]?.accepted ? "show" : "hidden"
                                        )}
                                    >
                                        Wymagane
                                    </div>

                                    <Checkbox
                                        name={`consents[${index}].accepted`}
                                        control={control}
                                        rules={{ required: true }}
                                    />
                                </>
                            )}
                        </div>

                        {hasChannels && (
                            <div className="consents--channels">
                                {Object.entries(channels).map(([channelKey, channelLabel]) => (
                                    <div key={channelKey} className="consents--item consents--channel">
                                        <Checkbox
                                            id={`consents[${index}].channels.${channelKey}`}
                                            name={`consents[${index}].channels.${channelKey}`}
                                            control={control}
                                            rules={{ required: true }}
                                        />

                                        <label
                                            htmlFor={`consents[${index}].channels.${channelKey}`}
                                            className="form-label"
                                        >
                                            {channelLabel}
                                        </label>
                                    </div>
                                ))}
                            </div>
                        )}

                    </div>
                );
            })}
        </div>
    );
}

Consents.propTypes = {
    consents: PropTypes.array.isRequired,
    control: PropTypes.any.isRequired,
    errors: PropTypes.any.isRequired,
};

export default React.memo(Consents);